<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-money-check"></i> {{ _('MobilePay payment attempts') }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6 filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 filtercol" style="min-height: 60px">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">{{ _('Type') }}</div>
              <select class="form-control" id="typeFilter" v-model="type">
                <option value="all">{{ _('All') }}</option>
                <option value="order">{{ _('All orders') }}</option>
                <option value="pospayment">{{ _('All POS transactions') }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <Datatable :url="attemptsUrl" :search="search" :type-filter="type" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable } from '#components'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      attempts: [],
      search: '',
      type: 'all',
      tableOptions: {
        responsiveLayoutCollapseFormatter: this.collapseFormatter(),
        columns: [
        {
          title: _('Reference'),
          field: 'reference',
          widthGrow: 5,
          responsive: 0,
          headerSort: false
        },
        {
          title: _('Created'),
          field: 'created',
          widthGrow: 5,
          responsive: 0,
          formatter: this.dateAndTimeFormatter(),
          headerSort: false
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 3,
          responsive: 0,
          hozAlign: 'left',
          headerSort: false,
          formatter: this.mobilepayAttemptTypeFormatter()
        },
        {
          title: _('Order'),
          field: 'order_id',
          widthGrow: 2,
          responsive: 0,
          hozAlign: 'left',
          headerSort: false,
        },
        {
          title: _('Transaction'),
          field: 'bill_id',
          widthGrow: 2,
          responsive: 0,
          hozAlign: 'left',
          headerSort: false,
        },
        ],
        initialSort: [{
          column: 'created',
          dir: 'desc'
        }],
        rowClick (e, row) {
          $this.openAttempt(row)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    attemptsUrl () {
      return this.baseDomain + this.shopId + '/mobilepayhandler.json?apikey=' + this.apiKey + this.versionStr
    },
    showFilters () {
      return false
    }
  },
  methods: {
    reload (url) {
      this.$refs.datatable.reload(url)
    },
    openAttempt (row) {
      let reference = row.getCell('reference').getValue()
      if (reference) {
        this.EventBus.$emit('showDetailsColumn', {
          shopId: this.shopId,
          component: 'MobilepayAttemptDetails',
          title: this._('MobilePay payment attempt') + ' (' + reference + ')',
          width: 6,
          data: {
            reference: reference,
            trail: this.componentTrail
          }
        })
      } 
    },
  },
  components: {
    Datatable
  }
}

</script>